var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWelcomeIlustration(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 360 360",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_343_19042)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M338.708 179.71C333.883 181.66 315.839 184.389 311.31 186.953C266.237 210.079 272.733 255.4 252.976 272.469C227.326 294.624 170.82 356.079 113.231 343.625C55.6428 331.171 18.3066 260.411 16.2964 216.892C14.2862 173.372 67.7003 154.856 94.0814 135.165C120.462 115.474 112.83 53.3376 137.345 32.0821C161.86 10.8267 228.846 16.4644 252.288 33.7915C275.73 51.1186 339.576 118.59 351.785 136.298C362.176 151.345 350.394 174.937 338.708 179.71Z",
    fill: "url(#paint0_linear_343_19042)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M338.708 179.71C333.883 181.66 315.839 184.389 311.31 186.953C266.237 210.079 272.733 255.4 252.976 272.469C227.326 294.624 170.82 356.079 113.231 343.625C55.6428 331.171 18.3066 260.411 16.2964 216.892C14.2862 173.372 67.7003 154.856 94.0814 135.165C120.462 115.474 112.83 53.3376 137.345 32.0821C161.86 10.8267 228.846 16.4644 252.288 33.7915C275.73 51.1186 339.576 118.59 351.785 136.298C362.176 151.345 350.394 174.937 338.708 179.71Z",
    fill: "#1D1D1D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.224 147.121L215.351 86.4539L156.459 107.752L211.474 231.793L270.783 211.593L243.39 149.744",
    stroke: "#598CD9",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.895 106.654L162.658 113.332L184.83 163.334L237.206 144.082L215.023 94.157L184.622 105.29",
    stroke: "#598CD9",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.683 170.564L188.968 172.667L211.776 224.08L264.63 205.811L241.349 153.409L197.905 169.377",
    stroke: "#598CD9",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.513 152.961C239.571 152.961 241.24 151.293 241.24 149.234C241.24 147.176 239.571 145.508 237.513 145.508C235.455 145.508 233.787 147.176 233.787 149.234C233.787 151.293 235.455 152.961 237.513 152.961Z",
    stroke: "#598CD9",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.513 150.317C238.111 150.317 238.596 149.832 238.596 149.234C238.596 148.637 238.111 148.152 237.513 148.152C236.915 148.152 236.431 148.637 236.431 149.234C236.431 149.832 236.915 150.317 237.513 150.317Z",
    stroke: "#598CD9",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.88 186.668L349.953 181.53L294.522 56.3909L282.832 60.6224",
    stroke: "#598CD9",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.918 62.3972L235.629 77.6942L290.644 201.735L329.987 188.333",
    stroke: "#598CD9",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.377 114.024L294.194 64.0991L241.828 83.2737L264.001 133.276L316.377 114.024Z",
    stroke: "#598CD9",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.823 135.369L268.138 142.603L290.946 194.022L343.801 175.748L320.52 123.351L293.72 133.204",
    stroke: "#598CD9",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.684 122.903C318.742 122.903 320.411 121.235 320.411 119.177C320.411 117.118 318.742 115.45 316.684 115.45C314.626 115.45 312.957 117.118 312.957 119.177C312.957 121.235 314.626 122.903 316.684 122.903Z",
    stroke: "#598CD9",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.684 120.259C317.282 120.259 317.767 119.775 317.767 119.177C317.767 118.579 317.282 118.094 316.684 118.094C316.086 118.094 315.601 118.579 315.601 119.177C315.601 119.775 316.086 120.259 316.684 120.259Z",
    stroke: "#598CD9",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.4275 273.244L55.709 289.66L113.92 269.83L101.184 241.073",
    stroke: "#598CD9",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.5804 237.456L59.5137 147.002L1.70898 167.909L47.3813 270.887",
    stroke: "#598CD9",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.1453 217.834L80.9629 203.568L59.1911 154.564L7.78833 173.385L29.5549 222.466L39.798 218.698",
    stroke: "#598CD9",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.0276 212.723L33.6196 231.621L56.0003 282.093L107.882 264.157L85.0276 212.723Z",
    stroke: "#598CD9",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.9237 208.627C84.9237 209.347 84.71 210.052 84.3097 210.651C83.9094 211.25 83.3403 211.717 82.6746 211.993C82.0089 212.268 81.2763 212.341 80.5696 212.2C79.8628 212.059 79.2136 211.712 78.7041 211.203C78.1945 210.693 77.8476 210.044 77.707 209.337C77.5664 208.631 77.6385 207.898 77.9143 207.232C78.1901 206.567 78.657 205.998 79.2562 205.597C79.8553 205.197 80.5597 204.983 81.2803 204.983C82.2466 204.983 83.1733 205.367 83.8566 206.05C84.5399 206.734 84.9237 207.66 84.9237 208.627Z",
    stroke: "#598CD9",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.3263 208.627C82.3263 208.833 82.2653 209.034 82.1509 209.205C82.0365 209.376 81.8739 209.51 81.6837 209.588C81.4935 209.667 81.2842 209.688 81.0823 209.648C80.8803 209.607 80.6949 209.508 80.5493 209.363C80.4037 209.217 80.3046 209.032 80.2644 208.83C80.2242 208.628 80.2448 208.419 80.3236 208.228C80.4024 208.038 80.5358 207.876 80.707 207.761C80.8782 207.647 81.0795 207.586 81.2853 207.586C81.5614 207.586 81.8262 207.695 82.0214 207.891C82.2166 208.086 82.3263 208.351 82.3263 208.627Z",
    stroke: "#598CD9",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.673 269.242C332.673 269.242 329.977 250.374 314.883 247.678C299.789 244.982 298.149 258.999 296.01 260.076C293.871 261.153 287.922 253.606 283.071 256.844C278.22 260.081 275.519 267.087 275.519 267.087C275.519 267.087 271.209 263.313 267.436 266.01C263.662 268.706 258.806 271.938 258.806 271.938C258.806 271.938 252.337 269.242 249.099 270.324C245.862 271.407 242.094 274.634 242.094 274.634H355.86C355.86 274.634 353.164 267.087 347.231 264.391C341.297 261.695 334.292 271.938 332.673 269.242Z",
    fill: "#1D1D1D",
    stroke: "url(#paint1_linear_343_19042)",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.0395 148.691C65.0395 148.691 63.171 135.627 52.7197 133.759C42.2685 131.89 41.1442 141.597 39.6556 142.347C38.1671 143.096 34.0553 137.865 30.6929 140.103C27.3306 142.341 25.4881 147.197 25.4881 147.197C25.4881 147.197 22.5005 144.595 19.8877 146.453C17.2749 148.311 13.9126 150.56 13.9126 150.56C13.9126 150.56 9.43645 148.691 7.19318 149.436C4.9499 150.18 2.34229 152.423 2.34229 152.423H81.0912C81.0912 152.423 79.2227 147.218 75.1161 145.329C71.0095 143.44 66.1586 150.56 65.0395 148.691Z",
    fill: "#1D1D1D",
    stroke: "url(#paint2_linear_343_19042)",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.417 89.0665C334.417 89.0665 332.611 76.424 322.498 74.6179C312.385 72.8119 311.302 82.2014 309.855 82.9456C308.408 83.6899 304.442 78.61 301.189 80.7804C297.936 82.9508 296.135 87.6404 296.135 87.6404C296.135 87.6404 293.241 85.1109 290.717 86.9169C288.193 88.723 284.94 90.8934 284.94 90.8934C284.94 90.8934 280.604 89.0873 278.439 89.8108C276.274 90.5343 273.755 92.6995 273.755 92.6995H349.948C349.948 92.6995 348.142 87.6196 344.165 85.7927C340.189 83.9658 335.499 90.8726 334.417 89.0665Z",
    fill: "#1D1D1D",
    stroke: "url(#paint3_linear_343_19042)",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.76 291.956C142.76 291.956 141.198 281.025 132.449 279.464C123.7 277.903 122.763 286.027 121.519 286.652C120.275 287.276 116.834 282.904 114.019 284.778C111.203 286.652 109.647 290.717 109.647 290.717C109.647 290.717 107.143 288.526 104.962 290.092C102.781 291.659 99.9655 293.527 99.9655 293.527C99.9655 293.527 96.2129 291.966 94.3391 292.591C92.4654 293.215 90.2742 295.089 90.2742 295.089H156.198C156.198 295.089 154.637 290.717 151.202 289.15C147.767 287.584 143.702 293.517 142.76 291.956Z",
    stroke: "url(#paint4_linear_343_19042)",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.975 89.9566C93.975 89.9566 92.4135 79.0265 83.6642 77.465C74.9149 75.9036 73.9729 84.0283 72.7341 84.6529C71.4954 85.2775 68.0498 80.9054 65.234 82.7791C62.4182 84.6529 60.8567 88.7178 60.8567 88.7178C60.8567 88.7178 58.3584 86.5266 56.1724 88.0933C53.9863 89.6599 51.1705 91.5284 51.1705 91.5284C51.1705 91.5284 47.4231 89.967 45.5441 90.5916C43.6652 91.2162 41.4844 93.0899 41.4844 93.0899H107.414C107.414 93.0899 105.852 88.7178 102.412 87.1512C98.9716 85.5845 94.9118 91.518 93.975 89.9566Z",
    fill: "#1D1D1D",
    stroke: "url(#paint5_linear_343_19042)",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.785 226.875C250.655 225.287 250.265 221.149 250.265 221.149L227.364 218.026L226.77 219.239L225.147 223.549C225.147 223.549 203 226.973 195.479 230.575C195.906 236.363 196.662 242.122 197.743 247.824C199.351 255.548 201.798 266.15 201.798 266.15L200.46 267.108L200.382 269.19C200.382 269.19 198.009 272.464 196.218 273.874C194.428 275.285 193.038 275.706 193.59 276.32C194.141 276.935 196.478 277.054 199.195 276.456C201.912 275.857 204.921 274.259 205.347 274.067C205.774 273.874 207.57 273.255 207.57 273.255L200.736 282.988L199.549 283.055L198.321 284.164C196.183 283.877 194.068 283.441 191.992 282.858C189.124 281.994 188.614 281.91 188.812 283.123C189.009 284.336 191.492 287.49 194.298 289.52C197.103 291.55 199.95 293.33 199.95 293.33C199.95 293.33 200.866 294.131 201.694 293.876C202.521 293.621 204.551 289.244 204.551 289.244C204.551 289.244 206.753 286.99 207.809 286.121C208.979 285.042 210.05 283.861 211.01 282.592C212.15 281.208 220.754 274.264 223.689 268.326C226.625 262.387 227.916 258.551 229.274 257.468C230.632 256.386 245.456 241.812 247.491 239.663C249.526 237.513 250.931 228.467 250.785 226.875ZM216.522 256.303C215.507 257.703 209.844 268.274 209.844 268.274C209.844 268.274 209.324 265.833 209.412 265.323C209.501 264.812 208.476 263.86 208.476 263.86L207.679 238.481L225.376 240.735C225.376 240.735 217.542 254.897 216.522 256.303Z",
    fill: "#1D1D1D",
    stroke: "#1D1D1D",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.073 147.975C218.073 147.975 216.918 147.402 215.783 146.736C214.648 146.07 214.773 147.048 215.507 147.839C216.441 148.682 217.436 149.455 218.484 150.15C218.484 150.15 216.257 149.692 216.46 150.202C216.663 150.712 218.36 151.477 220.462 151.535L219.036 147.938L218.073 147.975Z",
    fill: "white",
    stroke: "#1D1D1D",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.927 158.572C225.927 158.572 225.011 152.472 224.402 151.509C223.793 150.546 221.935 148.995 221.514 148.636C221.092 148.277 219.364 146.554 219.364 146.554C219.05 145.594 218.657 144.663 218.188 143.769C217.454 142.4 216.866 143.072 216.944 144.331C217.022 145.591 218.073 147.975 218.073 147.975C218.073 147.975 219.447 150.119 219.666 151.098C219.796 152.308 219.82 153.527 219.739 154.741C218.525 154.224 217.339 153.645 216.184 153.008C215.143 152.352 214.503 152.727 214.622 153.617C214.742 154.507 216.028 154.996 216.434 155.449C216.84 155.902 218.661 157.062 219.676 157.9C220.405 158.607 220.984 159.453 221.378 160.388L225.927 158.572Z",
    fill: "white",
    stroke: "#1D1D1D",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.927 158.572C225.927 158.572 222.612 158.894 221.602 159.779L220.598 160.669L221.753 163.547L227.057 161.637L225.927 158.572Z",
    fill: "url(#paint6_linear_343_19042)",
    stroke: "#1D1D1D",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.333 160.534C227.333 160.534 224.964 160.909 223.564 161.83C222.164 162.751 220.894 163.506 221.082 164.11C221.269 164.713 226.948 179.204 227.775 180.567C228.603 181.931 231.45 187.406 231.45 187.406L236.384 180.156L227.333 160.534Z",
    fill: "url(#paint7_linear_343_19042)",
    stroke: "#1D1D1D",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.195 183.695C230.195 183.695 229.675 184.554 228.566 190.691C227.457 196.827 228.046 205.441 228.217 207.211C228.389 208.98 227.208 214.305 227.208 214.305C227.208 214.305 224.99 218.677 226.042 219.957C227.093 221.238 233.328 222.56 239.054 223.361C244.779 224.163 251.972 222.565 252.191 221.732C252.409 220.899 252.045 218.786 252.045 218.786C252.045 218.786 250.562 202.833 248.922 194.745C247.283 186.657 242.395 179.224 242.395 179.224L230.195 183.695Z",
    fill: "url(#paint8_linear_343_19042)",
    stroke: "#1D1D1D",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.102 182.337L227.322 182.904L229.264 186.464L231.372 183.258L230.102 182.337Z",
    fill: "url(#paint9_linear_343_19042)",
    stroke: "#1D1D1D",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.322 182.904L226.88 186.069L228.478 184.991L227.322 182.904Z",
    fill: "url(#paint10_linear_343_19042)",
    stroke: "#1D1D1D",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.112 157.963C237.112 157.963 231.767 159.821 231.325 160.898C230.882 161.976 230.57 162.808 230.159 163.178C229.748 163.548 225.657 163.698 225.761 164.667C225.892 165.49 226.114 166.296 226.422 167.071C226.422 167.071 224.475 175.149 225.521 175.232C226.673 175.422 227.809 175.697 228.92 176.055L230.835 181.114L241.557 178.225L241.838 175.971C244.279 175.403 246.43 173.968 247.892 171.933C250.307 168.529 250.072 164.599 247.543 161.179C245.013 157.76 242.114 157.619 242.114 157.619C242.114 157.619 242.687 155.772 241.11 155.688C239.533 155.605 235.79 155.803 237.112 157.963Z",
    fill: "white",
    stroke: "#1D1D1D",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.114 157.619C242.114 157.619 242.687 155.771 241.11 155.688C239.533 155.605 235.79 155.787 237.112 157.947C237.112 157.947 241.172 159.587 241.047 160.362C240.922 161.138 238.023 161.013 238.039 161.986C238.055 162.959 238.721 165.369 238.304 165.744C237.888 166.119 236.259 166.91 236.602 167.493C236.749 167.676 236.938 167.823 237.152 167.919C237.367 168.016 237.601 168.061 237.836 168.05C237.836 168.05 240.771 166.858 240.933 168.05C241.094 169.242 240.438 171.063 239.548 171.625C239.001 171.965 238.393 172.194 237.758 172.302C237.758 172.302 237.362 173.65 238.939 174.795C239.778 175.448 240.782 175.857 241.838 175.977C244.279 175.408 246.43 173.973 247.892 171.938C250.307 168.534 250.072 164.604 247.543 161.184C245.013 157.765 242.114 157.619 242.114 157.619Z",
    fill: "#1D1D1D",
    stroke: "#1D1D1D",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.147 161.299C232.362 161.264 232.581 161.272 232.793 161.322C233.004 161.373 233.204 161.464 233.38 161.592C233.556 161.72 233.705 161.881 233.819 162.067C233.932 162.252 234.008 162.458 234.042 162.673",
    stroke: "#1D1D1D",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.085 164.172C231.804 164.505 231.45 164.666 231.293 164.531C231.137 164.396 231.236 164.011 231.517 163.688C231.798 163.365 232.152 163.199 232.308 163.329C232.465 163.459 232.366 163.865 232.085 164.172Z",
    fill: "#1D1D1D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.14 168.903C227.14 168.903 229.081 169.46 230.07 168.508",
    stroke: "#1D1D1D",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.773 172.297L236.628 171.5C236.194 171.881 235.713 172.205 235.197 172.463",
    stroke: "#1D1D1D",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.305 181.416L230.669 185.59L243.837 179.937L242.473 177.189L229.305 181.416Z",
    fill: "url(#paint11_linear_343_19042)",
    stroke: "#1D1D1D",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.029 194.794L217.602 185.861C217.269 185.461 216.675 185.406 216.275 185.739L216.167 185.828C215.767 186.161 215.712 186.755 216.045 187.155L223.472 196.088C223.804 196.488 224.398 196.543 224.798 196.21L224.907 196.12C225.307 195.788 225.361 195.194 225.029 194.794Z",
    fill: "#DBC958",
    stroke: "#1D1D1D",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.267 187.39L218.628 184.216L217.276 185.341L219.914 188.514L221.267 187.39Z",
    fill: "#DBC958",
    stroke: "#1D1D1D",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.861 194.118L224.222 190.944L222.87 192.068L225.508 195.242L226.861 194.118Z",
    fill: "#DBC958",
    stroke: "#1D1D1D",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.368 186.309L218.201 188.514C218.371 188.718 218.452 188.981 218.428 189.245C218.404 189.509 218.276 189.752 218.072 189.922L213.097 194.058L209.986 190.316L214.957 186.183C215.057 186.098 215.174 186.034 215.3 185.995C215.425 185.955 215.557 185.941 215.688 185.953C215.82 185.964 215.947 186.002 216.064 186.063C216.18 186.124 216.284 186.208 216.368 186.309Z",
    fill: "#DBC958",
    stroke: "#1D1D1D",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.275 193.416L224.109 195.621C224.278 195.825 224.36 196.088 224.335 196.352C224.311 196.615 224.183 196.859 223.979 197.028L219 201.168L215.889 197.426L220.868 193.286C221.072 193.117 221.334 193.035 221.598 193.06C221.862 193.084 222.106 193.212 222.275 193.416Z",
    fill: "#DBC958",
    stroke: "#1D1D1D",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.904 192.822L218.413 191.029L214.879 193.967L216.37 195.76L219.904 192.822Z",
    fill: "#DBC958",
    stroke: "#1D1D1D",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.406 195.885L214.681 192.607L213.668 193.449L216.393 196.727L217.406 195.885Z",
    fill: "#DBC958",
    stroke: "#1D1D1D",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.706 203.229L199.606 195.89L210.026 190.264L213.139 194.011L205.706 203.229Z",
    fill: "#DBC958",
    stroke: "#1D1D1D",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.504 203.26C205.165 203.541 203.547 202.141 201.86 200.137C200.174 198.134 199.117 196.281 199.456 196C199.794 195.718 201.413 197.119 203.099 199.122C204.785 201.126 205.842 202.979 205.504 203.26Z",
    fill: "#DBC958",
    stroke: "#1D1D1D",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.609 210.334L205.509 202.995L215.934 197.368L219.047 201.111L211.609 210.334Z",
    fill: "#DBC958",
    stroke: "#1D1D1D",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.411 210.365C211.073 210.646 209.449 209.246 207.768 207.242C206.087 205.238 205.025 203.385 205.358 203.104C205.691 202.823 207.32 204.223 209.001 206.227C210.682 208.231 211.749 210.084 211.411 210.365Z",
    fill: "#DBC958",
    stroke: "#1D1D1D",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.961 192.795L218.236 189.517L217.223 190.359L219.948 193.637L220.961 192.795Z",
    fill: "#DBC958",
    stroke: "#1D1D1D",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.771 204.176L229.003 202.901C229.003 202.901 227.619 208.913 227.661 208.678C227.702 208.444 232.017 210.032 232.017 210.032L233.771 204.176Z",
    fill: "url(#paint12_linear_343_19042)",
    stroke: "#1D1D1D",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.481 184.19C238.481 184.19 235.603 186.319 236.238 189.66C236.873 193.002 241.547 205.379 241.547 205.379C241.547 205.379 233.667 203.37 233.131 203.755C232.595 204.14 231.08 209.48 232.017 210.047C232.954 210.615 242.473 214.133 247.241 214.919C252.009 215.705 253.836 215.132 254.189 214.399C254.543 213.665 250.598 198.336 249.911 195.302C249.224 192.268 247.626 186.162 246.007 184.476C244.389 182.79 243.327 182.535 241.781 182.831",
    fill: "url(#paint13_linear_343_19042)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.481 184.19C238.481 184.19 235.603 186.319 236.238 189.66C236.873 193.002 241.547 205.379 241.547 205.379C241.547 205.379 233.667 203.37 233.131 203.755C232.595 204.14 231.08 209.48 232.017 210.047C232.954 210.615 242.473 214.133 247.241 214.919C252.009 215.705 253.836 215.132 254.189 214.399C254.543 213.665 250.598 198.336 249.911 195.302C249.224 192.268 247.626 186.162 246.007 184.476C244.389 182.79 243.327 182.535 241.781 182.831",
    stroke: "#1D1D1D",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.547 205.379C241.547 205.379 246.642 206.055 248.219 207.029",
    stroke: "#1D1D1D",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.037 205.733C248.037 205.733 249.833 206.82 249.901 207.856",
    stroke: "#1D1D1D",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.003 202.901C229.003 202.901 226.057 201.626 225.709 201.34C225.36 201.053 223.106 197.592 222.013 196.468C220.92 195.344 218.203 193.709 217.589 194.084C216.975 194.459 217.589 195.125 218.308 195.463C219.13 195.929 219.885 196.505 220.551 197.176C220.722 197.521 220.848 197.887 220.926 198.264C220.926 198.264 216.954 197.452 215.955 197.285C214.956 197.119 213.753 197.244 213.665 197.78C213.576 198.316 213.665 198.253 213.883 198.368C213.781 198.602 213.742 198.858 213.77 199.112C213.797 199.366 213.89 199.608 214.04 199.815C214.56 200.455 216.59 201.1 217.449 201.636C218.147 202.167 218.762 202.801 219.27 203.515C218.57 203.488 217.874 203.401 217.188 203.255C216.356 203.036 215.19 201.975 214.971 202.334C214.753 202.693 215.986 204.317 216.704 204.754C218.689 205.593 220.757 206.223 222.872 206.633C224.111 206.758 227.702 207.981 227.702 207.981L229.003 202.901Z",
    fill: "white",
    stroke: "#1D1D1D",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.883 198.378C213.883 198.378 218.469 199.763 219.879 200.788",
    stroke: "#1D1D1D",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.926 198.274L222.055 199.091",
    stroke: "#1D1D1D",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.8634 135.228V135.379L81.8062 135.249L81.8634 135.228Z",
    fill: "#1D1D1D",
    stroke: "#1D1D1D",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.614 261.003L134.495 261.05L121.738 230.591L134.614 261.003Z",
    fill: "#1D1D1D",
    stroke: "#1D1D1D",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.675 238.929L137.238 259.988H137.232L142.192 208.455L104.177 126.469L133.844 114.831L191.675 238.929Z",
    fill: "#1D1D1D",
    stroke: "#1D1D1D",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.192 208.455L139.788 209.272L101.819 127.395L83.0344 86.8858L85.4443 86.0686L104.176 126.468L142.192 208.455Z",
    fill: "#DBC958",
    stroke: "#1D1D1D",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.232 259.988L137.18 260.555L134.771 261.367L134.656 260.987L134.812 260.925L137.232 259.988Z",
    fill: "#DBC958",
    stroke: "#1D1D1D",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.656 260.987H134.614L134.77 261.351L134.812 260.909L134.656 260.987Z",
    fill: "#DBC958",
    stroke: "#1D1D1D",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.819 127.395L83.0346 86.886L81.8635 135.239V135.39L121.738 230.591L134.614 261.003H134.656L134.812 260.94L139.788 209.288L101.819 127.395ZM130.445 245.544L129.238 242.687L106.092 188.005L86.6363 142.067L86.8029 133.292L87.3546 102.714L88.3487 104.853L99.2789 128.394L109.553 150.551L109.678 150.822L134.344 204.015L130.445 245.544Z",
    fill: "#DBC958",
    stroke: "#1D1D1D",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.553 150.551L108.757 159.139C107.351 159.826 106.925 161.997 107.799 164.094C107.915 164.378 108.056 164.652 108.221 164.911L107.731 170.173L106.092 188.005L86.6362 142.067L86.8028 133.292L87.3545 102.714L88.3486 104.853L99.2787 128.394L109.553 150.551Z",
    fill: "#DBC958",
    stroke: "#1D1D1D",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.344 204.02L130.44 245.539L129.232 242.682L106.076 188.005L111.9 201.621L113.16 188.479L115.533 163.636L109.678 150.827L134.344 204.02Z",
    fill: "#DBC958",
    stroke: "#1D1D1D",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.192 208.455L137.232 259.988L134.812 260.925L139.788 209.272L142.192 208.455Z",
    fill: "#DBC958",
    stroke: "#1D1D1D",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.812 260.925L137.232 259.988L137.18 260.555L134.771 261.367L134.812 260.925Z",
    fill: "#DBC958",
    stroke: "#1D1D1D",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.192 208.455L137.237 259.988H137.232L142.192 208.455Z",
    fill: "#DBC958",
    stroke: "#1D1D1D",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.533 163.636L113.16 188.479L111.9 201.621L106.092 188.005L107.747 170.179L108.236 164.917C109.241 166.582 110.896 167.467 112.213 166.941C112.537 166.802 112.825 166.592 113.059 166.328C113.292 166.063 113.463 165.75 113.561 165.411C114.492 164.75 114.742 163.136 114.081 161.575C113.42 160.014 112.036 158.973 110.875 159.207C110.574 159.052 110.245 158.961 109.907 158.939C109.569 158.918 109.231 158.966 108.913 159.082L108.767 159.15L109.563 150.562L109.688 150.832L115.533 163.636Z",
    fill: "#DBC958",
    stroke: "#1D1D1D",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.545 165.427C113.883 164.272 113.797 163.035 113.301 161.939C112.85 160.767 111.985 159.8 110.87 159.222C112.031 159.014 113.41 160.003 114.076 161.591C114.742 163.178 114.477 164.745 113.545 165.427Z",
    fill: "#DBC958",
    stroke: "#1D1D1D",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.3 161.918C112.85 160.746 111.985 159.779 110.87 159.202C110.569 159.046 110.239 158.955 109.902 158.934C109.564 158.912 109.226 158.961 108.908 159.077L108.762 159.144C107.357 159.831 106.93 162.002 107.804 164.099C107.921 164.383 108.062 164.657 108.226 164.916C109.23 166.582 110.885 167.467 112.202 166.941C112.526 166.802 112.815 166.592 113.048 166.327C113.281 166.063 113.453 165.75 113.55 165.411C113.888 164.254 113.799 163.015 113.3 161.918ZM110.37 164.521C110.346 164.646 110.292 164.763 110.213 164.862C110.134 164.962 110.033 165.041 109.917 165.093C109.444 165.281 108.824 164.885 108.543 164.203C108.262 163.522 108.413 162.819 108.887 162.642C109.054 162.579 109.239 162.579 109.407 162.642C109.596 162.726 109.767 162.846 109.909 162.996C110.051 163.146 110.162 163.323 110.235 163.516C110.38 163.825 110.427 164.17 110.37 164.505V164.521Z",
    fill: "white",
    stroke: "#1D1D1D",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.37 164.505C110.346 164.63 110.292 164.747 110.213 164.847C110.134 164.946 110.033 165.025 109.917 165.078C109.444 165.265 108.824 164.87 108.543 164.188C108.262 163.506 108.413 162.803 108.887 162.626C109.055 162.563 109.24 162.563 109.407 162.626C109.596 162.71 109.767 162.831 109.909 162.981C110.051 163.131 110.162 163.308 110.235 163.501C110.383 163.814 110.43 164.165 110.37 164.505Z",
    fill: "white",
    stroke: "#1D1D1D",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.592 233.729C175.738 234 182.806 228.587 189.78 224.361C211.999 210.891 241.308 208.262 264.178 220.566C272.193 224.876 279.131 231.668 280.412 241.079C281.135 246.351 279.662 252.04 275.925 255.834C272.188 259.629 266.109 261.169 261.253 258.988C259.046 257.999 257.089 256.209 256.402 253.898C255.715 251.587 256.475 248.771 258.536 247.512C260.212 246.471 262.32 246.611 264.261 246.393C266.202 246.174 268.425 245.305 268.945 243.405C269.109 242.611 269.073 241.788 268.841 241.011C265.718 227.791 247.564 220.535 235.598 218.89C222.123 217.043 208.341 220.426 196.042 226.234C191.487 228.384 187.074 230.872 182.327 232.543C177.58 234.213 172.36 235.031 167.498 233.724L167.592 233.729Z",
    fill: "url(#paint14_linear_343_19042)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.57 131.496C115.57 131.496 124.699 121.186 121.186 112.639C117.672 104.093 105.868 104.093 104.395 94.9429C102.922 85.7928 115.294 85.2203 123.84 93.7666C132.387 102.313 132.381 111.151 127.962 118.807C123.544 126.463 115.57 131.496 115.57 131.496Z",
    fill: "url(#paint15_linear_343_19042)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.158 248.797C147.158 248.797 159.65 242.932 166.827 248.725C174.004 254.517 170.725 265.833 179.074 269.809C187.422 273.786 191.451 262.08 185.668 251.478C179.886 240.876 171.386 238.393 162.793 240.485C154.2 242.578 147.158 248.797 147.158 248.797Z",
    fill: "url(#paint16_linear_343_19042)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.796 145.128C134.796 145.128 151.884 143.363 159.545 122.747C167.207 102.131 167.509 87.9581 177.518 83.8307C185.012 80.7443 186.059 86.1885 183.113 91.1955C174.114 106.498 168.539 123.871 155.35 136.347C150.557 140.881 141.844 146.929 134.796 145.128Z",
    fill: "url(#paint17_linear_343_19042)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.759 91.727C151.5 88.6412 149.599 85.5391 146.513 84.7983C143.427 84.0574 140.325 85.9584 139.584 89.0442C138.843 92.13 140.744 95.2322 143.83 95.973C146.916 96.7138 150.018 94.8129 150.759 91.727Z",
    fill: "url(#paint18_linear_343_19042)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.563 146.593C262.289 143.503 260.373 140.411 257.284 139.685C254.194 138.959 251.101 140.875 250.376 143.965C249.65 147.054 251.566 150.147 254.655 150.873C257.745 151.598 260.838 149.682 261.563 146.593Z",
    fill: "url(#paint19_linear_343_19042)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.753 230.377C164.486 227.289 162.577 224.192 159.489 223.459C156.401 222.726 153.304 224.635 152.571 227.723C151.838 230.811 153.747 233.908 156.835 234.641C159.923 235.373 163.02 233.464 163.753 230.377Z",
    fill: "url(#paint20_linear_343_19042)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.346 197.707C187.639 197.707 189.499 195.847 189.499 193.553C189.499 191.26 187.639 189.4 185.346 189.4C183.052 189.4 181.192 191.26 181.192 193.553C181.192 195.847 183.052 197.707 185.346 197.707Z",
    fill: "url(#paint21_linear_343_19042)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.34 116.762C155.34 117.461 155.133 118.144 154.744 118.725C154.356 119.306 153.804 119.759 153.158 120.027C152.512 120.294 151.802 120.364 151.116 120.228C150.431 120.091 149.801 119.755 149.307 119.261C148.813 118.766 148.476 118.137 148.34 117.451C148.203 116.766 148.273 116.055 148.541 115.409C148.808 114.763 149.261 114.211 149.842 113.823C150.424 113.435 151.107 113.228 151.806 113.228C152.743 113.229 153.641 113.602 154.303 114.264C154.966 114.927 155.338 115.825 155.34 116.762Z",
    fill: "url(#paint22_linear_343_19042)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.984 171.896C260.935 171.896 262.518 170.314 262.518 168.362C262.518 166.41 260.935 164.828 258.984 164.828C257.032 164.828 255.449 166.41 255.449 168.362C255.449 170.314 257.032 171.896 258.984 171.896Z",
    fill: "url(#paint23_linear_343_19042)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.283 123.523C234.333 124.564 239.887 131.075 241.964 133.563C242.031 133.645 242.073 133.746 242.085 133.852C242.097 133.958 242.077 134.065 242.029 134.16C241.982 134.255 241.907 134.335 241.815 134.388C241.723 134.442 241.617 134.468 241.511 134.463C238.279 134.302 229.722 133.771 227.671 132.746C225.62 131.72 219.895 125.115 217.751 122.591C217.682 122.509 217.638 122.408 217.625 122.301C217.613 122.194 217.632 122.086 217.68 121.99C217.728 121.893 217.803 121.813 217.896 121.759C217.989 121.705 218.096 121.679 218.204 121.685C221.509 121.883 230.227 122.497 232.283 123.523Z",
    fill: "url(#paint24_linear_343_19042)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.351 107.814C224.913 106.144 232.772 102.698 235.749 101.428C235.848 101.387 235.956 101.375 236.061 101.394C236.166 101.413 236.264 101.462 236.341 101.535C236.419 101.609 236.474 101.703 236.499 101.807C236.524 101.911 236.519 102.02 236.483 102.12C235.395 105.17 232.434 113.212 230.857 114.882C229.28 116.553 221.311 120.145 218.282 121.461C218.183 121.505 218.073 121.518 217.966 121.5C217.859 121.481 217.76 121.432 217.681 121.358C217.602 121.283 217.547 121.187 217.522 121.082C217.498 120.976 217.505 120.866 217.543 120.764C218.683 117.662 221.779 109.485 223.351 107.814Z",
    fill: "url(#paint25_linear_343_19042)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.095 112.78C202.943 110.646 208.975 104.556 211.276 102.282C211.352 102.207 211.449 102.156 211.554 102.135C211.659 102.115 211.767 102.125 211.866 102.164C211.966 102.204 212.051 102.272 212.113 102.359C212.174 102.446 212.209 102.55 212.213 102.657C212.322 105.894 212.525 114.461 211.692 116.595C210.86 118.729 204.728 124.985 202.381 127.333C202.306 127.411 202.209 127.466 202.102 127.489C201.996 127.513 201.885 127.504 201.783 127.463C201.682 127.423 201.595 127.353 201.534 127.263C201.472 127.173 201.439 127.067 201.439 126.958C201.371 123.653 201.246 114.94 202.095 112.78Z",
    fill: "url(#paint26_linear_343_19042)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.359 138.585C209.361 137.451 204.156 130.643 202.22 128.046C202.138 127.965 202.086 127.86 202.07 127.747C202.054 127.634 202.076 127.519 202.133 127.419C202.189 127.32 202.276 127.242 202.381 127.197C202.486 127.152 202.603 127.143 202.714 127.171C205.936 127.504 214.451 128.483 216.45 129.617C218.448 130.752 223.809 137.648 225.818 140.277C225.886 140.364 225.927 140.47 225.934 140.58C225.941 140.691 225.915 140.801 225.859 140.896C225.803 140.992 225.719 141.068 225.619 141.116C225.519 141.163 225.407 141.179 225.298 141.162C222.029 140.787 213.353 139.715 211.359 138.585Z",
    fill: "url(#paint27_linear_343_19042)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.132 123.913C185.575 121.659 190.389 114.544 192.237 111.911C192.297 111.821 192.382 111.752 192.482 111.711C192.582 111.67 192.691 111.659 192.797 111.68C192.903 111.701 193 111.753 193.076 111.83C193.152 111.906 193.204 112.003 193.226 112.108C193.928 115.268 195.693 123.653 195.25 125.906C194.808 128.16 189.962 135.431 188.099 138.169C188.038 138.258 187.952 138.327 187.852 138.367C187.752 138.408 187.643 138.418 187.537 138.397C187.431 138.376 187.334 138.325 187.257 138.249C187.18 138.173 187.127 138.077 187.105 137.971C186.418 134.718 184.685 126.167 185.132 123.913Z",
    fill: "url(#paint28_linear_343_19042)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.972 147.584C196.796 146.835 190.436 141.094 188.042 138.903C187.962 138.83 187.906 138.736 187.879 138.632C187.852 138.528 187.857 138.418 187.892 138.316C187.926 138.215 187.99 138.125 188.075 138.059C188.16 137.993 188.263 137.954 188.37 137.945C191.597 137.685 200.148 137.086 202.319 137.836C204.489 138.585 211.032 144.378 213.483 146.601C213.562 146.673 213.619 146.767 213.646 146.871C213.672 146.976 213.668 147.085 213.633 147.187C213.598 147.289 213.535 147.378 213.45 147.444C213.365 147.51 213.262 147.55 213.155 147.558C209.86 147.793 201.142 148.329 198.972 147.584Z",
    fill: "url(#paint29_linear_343_19042)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.446 141.974C167.353 139.683 170.382 131.663 171.558 128.649C171.596 128.549 171.662 128.462 171.749 128.4C171.836 128.337 171.94 128.301 172.047 128.297C172.154 128.292 172.26 128.319 172.351 128.375C172.443 128.43 172.516 128.511 172.563 128.608C173.983 131.517 177.658 139.262 177.767 141.552C177.877 143.842 174.842 152.05 173.666 155.142C173.629 155.244 173.562 155.332 173.475 155.396C173.388 155.46 173.283 155.496 173.175 155.501C173.067 155.505 172.96 155.477 172.867 155.421C172.775 155.364 172.702 155.282 172.656 155.183C171.22 152.196 167.54 144.269 167.446 141.974Z",
    fill: "url(#paint30_linear_343_19042)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.418 161.783C184.133 161.559 176.607 157.463 173.78 155.886C173.687 155.834 173.612 155.755 173.562 155.66C173.513 155.565 173.492 155.458 173.503 155.352C173.513 155.245 173.554 155.144 173.621 155.061C173.688 154.977 173.778 154.915 173.879 154.882C176.955 153.872 185.127 151.296 187.412 151.519C189.697 151.743 197.41 155.85 200.315 157.437C200.409 157.489 200.487 157.568 200.537 157.663C200.588 157.759 200.609 157.867 200.598 157.975C200.588 158.082 200.546 158.184 200.478 158.268C200.41 158.352 200.319 158.414 200.216 158.447C197.062 159.431 188.703 161.986 186.418 161.783Z",
    fill: "url(#paint31_linear_343_19042)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.441 154.658C151.348 152.362 154.372 144.342 155.548 141.328C155.587 141.228 155.654 141.142 155.741 141.08C155.829 141.017 155.932 140.982 156.039 140.978C156.146 140.973 156.252 141 156.344 141.055C156.437 141.11 156.511 141.19 156.558 141.287C157.973 144.196 161.648 151.941 161.762 154.236C161.877 156.532 158.843 164.729 157.666 167.826C157.627 167.926 157.56 168.012 157.473 168.075C157.386 168.137 157.282 168.172 157.175 168.177C157.068 168.181 156.962 168.154 156.87 168.099C156.778 168.045 156.704 167.964 156.657 167.868C155.21 164.875 151.535 156.948 151.441 154.658Z",
    fill: "url(#paint32_linear_343_19042)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.413 174.447C168.128 174.223 160.602 170.127 157.776 168.549C157.683 168.497 157.606 168.419 157.557 168.325C157.507 168.23 157.486 168.123 157.496 168.017C157.506 167.91 157.546 167.809 157.613 167.725C157.679 167.642 157.768 167.579 157.87 167.545C160.946 166.54 169.122 163.959 171.402 164.183C173.682 164.406 181.395 168.518 184.3 170.106C184.395 170.156 184.473 170.234 184.524 170.329C184.576 170.424 184.598 170.532 184.588 170.639C184.578 170.747 184.536 170.849 184.468 170.932C184.4 171.016 184.309 171.078 184.206 171.11C181.041 172.11 172.714 174.67 170.413 174.447Z",
    fill: "url(#paint33_linear_343_19042)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.059 172.588C140.059 172.588 154.762 171.625 167.197 161.138C175.691 153.976 181.281 144.123 189.369 136.581C202.298 124.532 221.639 117.324 239.278 121.029",
    stroke: "url(#paint34_linear_343_19042)",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.957 117.579C254.231 117.896 261.57 122.325 264.324 124.027C264.414 124.084 264.487 124.165 264.532 124.262C264.577 124.359 264.594 124.467 264.579 124.573C264.564 124.679 264.519 124.778 264.448 124.859C264.378 124.939 264.286 124.998 264.183 125.027C261.06 125.896 252.785 128.108 250.51 127.785C248.236 127.463 240.72 123.018 237.883 121.305C237.791 121.249 237.717 121.167 237.671 121.069C237.625 120.971 237.609 120.862 237.624 120.755C237.64 120.648 237.686 120.548 237.758 120.467C237.83 120.386 237.924 120.328 238.029 120.301C241.225 119.442 249.682 117.256 251.957 117.579Z",
    fill: "url(#paint35_linear_343_19042)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.647 198.17C162.075 193.626 154.694 194.194 154.694 194.194C154.694 194.194 158.671 189.077 155.829 186.241C152.987 183.404 149.864 190.217 149.864 190.217C149.864 190.217 150.999 182.832 147.59 179.422C144.181 176.013 140.49 178.569 142.479 184.82C144.467 191.071 142.479 191.638 142.479 191.638L142.416 191.763C142.885 194.009 142.969 196.318 142.666 198.592C142.666 198.592 145.789 191.779 148.631 194.615C151.473 197.452 147.496 202.568 147.496 202.568C147.496 202.568 154.877 202.001 155.444 206.545C155.715 208.715 154.179 209.668 152.498 210.042C157.156 211.541 161.565 214.128 161.794 209.813C162.075 204.416 155.829 201.86 155.829 201.86C155.829 201.86 163.215 202.714 162.647 198.17Z",
    fill: "url(#paint36_linear_343_19042)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.374 183.019C151.374 183.019 148.573 173.884 150.442 172.765C152.311 171.646 155.1 172.953 155.47 176.122C155.839 179.292 151.374 183.019 151.374 183.019Z",
    fill: "url(#paint37_linear_343_19042)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.399 203.422C144.399 203.422 143.457 196.255 144.988 195.656C146.518 195.058 148.438 196.374 148.319 198.779C148.199 201.184 144.399 203.422 144.399 203.422Z",
    fill: "url(#paint38_linear_343_19042)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.719 191.3C157.719 191.3 164.787 184.877 166.593 186.095C168.399 187.313 168.409 190.394 165.703 192.08C162.996 193.767 157.719 191.3 157.719 191.3Z",
    fill: "url(#paint39_linear_343_19042)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.648 203.568C161.648 203.568 171.183 203 171.829 205.072C172.474 207.143 170.553 209.558 167.384 209.178C164.214 208.798 161.648 203.568 161.648 203.568Z",
    fill: "url(#paint40_linear_343_19042)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.635 204.499C142.635 204.499 152.17 203.942 152.815 206.024C153.461 208.106 151.54 210.511 148.37 210.131C145.201 209.751 142.635 204.499 142.635 204.499Z",
    fill: "url(#paint41_linear_343_19042)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.034 138.398C130.034 138.398 123.96 124.735 141.042 111.073C158.124 97.41 164.188 79.9426 153.18 71.2194C142.172 62.4961 130.799 71.2194 129.644 65.1453C128.488 59.0713 150.14 52.2426 162.288 65.1453C174.436 78.0481 169.122 92.4758 158.494 101.579C147.866 110.682 128.504 120.561 130.034 138.398Z",
    fill: "url(#paint42_linear_343_19042)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.003 198.623C253.003 198.623 272.641 200.184 278.803 212.098C284.966 224.012 291.508 219.416 293.049 216.335C297.504 207.424 285.877 202.657 279.277 200.694C274.54 199.317 269.68 198.402 264.766 197.962C260.795 197.587 256.699 198.914 253.003 198.623Z",
    fill: "url(#paint43_linear_343_19042)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.524 103.333C190.524 103.333 201.085 86.709 195.245 74.6182C189.405 62.5274 197.03 60.0447 200.419 60.6849C210.069 62.4441 206.732 75.222 204.583 81.5042C203.11 85.8083 201.215 89.9559 198.925 93.8864C196.723 97.6027 192.674 99.9448 190.524 103.333Z",
    fill: "url(#paint44_linear_343_19042)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_343_19042",
    x1: -46.8801,
    y1: 178.048,
    x2: 356.657,
    y2: 276.804,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#59D9C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#598CD9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_343_19042",
    x1: 242.094,
    y1: 247.334,
    x2: 254.482,
    y2: 298.961,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#59D9C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#598CD9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_343_19042",
    x1: 2.34229,
    y1: 133.52,
    x2: 10.9227,
    y2: 169.266,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#59D9C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#598CD9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_343_19042",
    x1: 273.755,
    y1: 74.3877,
    x2: 282.076,
    y2: 109.011,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#59D9C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#598CD9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_343_19042",
    x1: 90.2742,
    y1: 279.265,
    x2: 97.4567,
    y2: 309.189,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#59D9C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#598CD9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_343_19042",
    x1: 41.4844,
    y1: 77.2661,
    x2: 48.6664,
    y2: 107.19,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#59D9C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#598CD9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_343_19042",
    x1: 220.598,
    y1: 158.572,
    x2: 225.409,
    y2: 164.817,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#59D9C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#598CD9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_343_19042",
    x1: 221.063,
    y1: 160.534,
    x2: 244.188,
    y2: 173.718,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#59D9C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#598CD9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_343_19042",
    x1: 225.759,
    y1: 179.224,
    x2: 264.819,
    y2: 202.562,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#59D9C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#598CD9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_343_19042",
    x1: 227.322,
    y1: 182.337,
    x2: 231.449,
    y2: 186.386,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#59D9C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#598CD9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_343_19042",
    x1: 226.88,
    y1: 182.904,
    x2: 229.426,
    y2: 184.19,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#59D9C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#598CD9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_343_19042",
    x1: 229.305,
    y1: 177.189,
    x2: 236.585,
    y2: 189.782,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#59D9C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#598CD9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_343_19042",
    x1: 227.66,
    y1: 202.901,
    x2: 234.706,
    y2: 208.941,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#59D9C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#598CD9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_343_19042",
    x1: 231.718,
    y1: 182.725,
    x2: 262.178,
    y2: 203.761,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#59D9C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#598CD9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_343_19042",
    x1: 167.498,
    y1: 212.649,
    x2: 201.22,
    y2: 293.21,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6A924"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F2EB91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_343_19042",
    x1: 104.275,
    y1: 87.7024,
    x2: 143.146,
    y2: 111.324,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#59D9C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#598CD9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_343_19042",
    x1: 147.158,
    y1: 239.805,
    x2: 176.691,
    y2: 279.34,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#59D9C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#598CD9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_343_19042",
    x1: 134.796,
    y1: 82.9307,
    x2: 195.746,
    y2: 131.517,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#59D9C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#598CD9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_343_19042",
    x1: 138.243,
    y1: 94.6316,
    x2: 152.1,
    y2: 86.1397,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6A924"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F2EB91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_343_19042",
    x1: 249.062,
    y1: 149.558,
    x2: 262.877,
    y2: 140.999,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#59D9C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#598CD9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_343_19042",
    x1: 151.244,
    y1: 233.314,
    x2: 165.08,
    y2: 224.786,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#59D9C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#598CD9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_343_19042",
    x1: 181.192,
    y1: 189.4,
    x2: 189.499,
    y2: 197.707,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6A924"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F2EB91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_343_19042",
    x1: 148.272,
    y1: 113.228,
    x2: 155.34,
    y2: 120.296,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#59D9C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#598CD9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_343_19042",
    x1: 255.449,
    y1: 164.828,
    x2: 262.518,
    y2: 171.896,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6A924"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F2EB91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_343_19042",
    x1: 217.622,
    y1: 121.685,
    x2: 228.11,
    y2: 141.765,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6A924"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F2EB91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_343_19042",
    x1: 217.508,
    y1: 101.385,
    x2: 237.598,
    y2: 120.36,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6A924"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F2EB91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_343_19042",
    x1: 201.39,
    y1: 102.125,
    x2: 219.826,
    y2: 110.063,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#59D9C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#598CD9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_343_19042",
    x1: 202.065,
    y1: 127.155,
    x2: 214.302,
    y2: 147.998,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#59D9C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#598CD9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_343_19042",
    x1: 185.059,
    y1: 111.67,
    x2: 202.947,
    y2: 118.535,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6A924"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F2EB91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_343_19042",
    x1: 187.862,
    y1: 137.472,
    x2: 195.186,
    y2: 155.48,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6A924"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F2EB91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_343_19042",
    x1: 167.444,
    y1: 128.296,
    x2: 185.496,
    y2: 135.148,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#59D9C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#598CD9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_343_19042",
    x1: 173.5,
    y1: 151.506,
    x2: 180.328,
    y2: 169.491,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#59D9C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#598CD9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_343_19042",
    x1: 151.439,
    y1: 140.977,
    x2: 169.49,
    y2: 147.83,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6A924"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F2EB91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_343_19042",
    x1: 157.493,
    y1: 164.169,
    x2: 164.325,
    y2: 182.157,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6A924"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F2EB91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear_343_19042",
    x1: 140.059,
    y1: 120.054,
    x2: 183.509,
    y2: 202.117,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#59D9C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#598CD9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear_343_19042",
    x1: 237.618,
    y1: 117.546,
    x2: 244.451,
    y2: 135.485,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#59D9C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#598CD9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint36_linear_343_19042",
    x1: 141.919,
    y1: 177.903,
    x2: 172.301,
    y2: 196.298,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#59D9C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#598CD9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint37_linear_343_19042",
    x1: 149.799,
    y1: 172.371,
    x2: 158.653,
    y2: 177.104,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#59D9C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#598CD9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint38_linear_343_19042",
    x1: 144.113,
    y1: 195.513,
    x2: 150.675,
    y2: 199.007,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#59D9C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#598CD9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint39_linear_343_19042",
    x1: 157.719,
    y1: 185.941,
    x2: 163.919,
    y2: 195.283,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#59D9C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#598CD9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint40_linear_343_19042",
    x1: 161.648,
    y1: 203.496,
    x2: 166.504,
    y2: 212.243,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#59D9C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#598CD9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint41_linear_343_19042",
    x1: 142.635,
    y1: 204.432,
    x2: 147.514,
    y2: 213.193,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#59D9C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#598CD9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint42_linear_343_19042",
    x1: 128.985,
    y1: 57.8118,
    x2: 193.439,
    y2: 90.0264,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6A924"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F2EB91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint43_linear_343_19042",
    x1: 253.003,
    y1: 197.895,
    x2: 271.256,
    y2: 232.025,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6A924"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F2EB91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint44_linear_343_19042",
    x1: 190.524,
    y1: 60.5925,
    x2: 219.123,
    y2: 71.5706,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6A924"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F2EB91"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_343_19042"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 360,
    height: 360,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWelcomeIlustration);
export default __webpack_public_path__ + "static/media/welcome-ilustration.fd5775917ead8d6ed16d10f40e1bd900.svg";
export { ForwardRef as ReactComponent };